import { MYDRA_WORKSPACE_ID_HEADER_NAME } from '@/config/system'
import { PlaybooksService } from '@/services/playbook'
import { useWorkspaceContext } from '@/shared/hooks/useWorkspaceContext'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

export const useDeletePlaybook = (
  options: Omit<
    UseMutationOptions<void, Error, string>,
    'mutationFn' | 'mutationKey'
  > = {}
) => {
  const queryClient = useQueryClient()
  const { workspaceId } = useWorkspaceContext()

  return useMutation({
    mutationKey: [
      PlaybooksService.path,
      'delete',
      ...(workspaceId ? ['workspaceId', workspaceId] : []),
    ],
    mutationFn: (playbookId: string) =>
      PlaybooksService.deletePlaybook(playbookId, {
        headers: {
          [MYDRA_WORKSPACE_ID_HEADER_NAME]: workspaceId,
        },
      }),
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: ['playbooks'],
        exact: false,
      })
      options?.onSuccess?.(...args)
    },
    ...options,
  })
}
